import React from 'react';
import { View, TouchableOpacity, Text, Image, ActivityIndicator, Platform, Dimensions, ScrollView } from 'react-native';
import Colors from '../../../constants/Colors';
import CS from '../../../constants/Styles';
import Images from '../../../constants/Images';
import { AntDesign } from '@expo/vector-icons';
import { containerDimensions } from '../../../utils/Functions';
import styles from './styles';
import CachedImage from '../../../components/CachedImage';
import Alert from '../../../components/Alert';

export default function ProjectPhoto({ ...props }) {
  const [alertOptions, setAlertOptions] = React.useState({});
  // const [rowItems, setRowItems] = React.useState(props.captions ? 2 : 4);
  const [rowItems, setRowItems] = React.useState(props.rowItems || 4);
  const [loading, setLoading] = React.useState(Platform.OS === 'web' ? true : false);
  const [containerStyle, setContainerStyle] = React.useState(containerDimensions(rowItems, props.which, (props.photo.existing ? Images.project.width : props.photo.width), (props.photo.existing ? Images.project.height : props.photo.height), props.isScrollable));
  
  React.useEffect(() => {
    const subscription = Dimensions.addEventListener('change', onChangeDimensions);
    return () => {
      subscription.remove();
      // Dimensions.removeEventListener('change', onChangeDimensions);
    }
  }, []);
  // React.useEffect(() => {
  //   const listener = Dimensions.addEventListener('change', onChangeDimensions);
  //   return () => {
  //     listener.remove();
  //   }
  // }, []);

  const onChangeDimensions = () => {
    setContainerStyle(containerDimensions(rowItems, props.which, (props.photo.existing ? Images.project.width : props.photo.width), (props.photo.existing ? Images.project.height : props.photo.height), props.isScrollable));
  }

  const loadStart = (e) => {
    if(Platform.OS !== 'web'){
      console.log('load start', e);
      setLoading(true);
    }
  }

  const loadEnd = (e) => {
    // if (Platform.OS !== 'web') {
      console.log('load end', e);
      setLoading(false);
    // }
  }

  const promptDeleteItem = (item) => {
    if(item.existing){
      setAlertOptions({
        visible: true,
        title: 'Confirm',
        message: `Are you sure you want to delete this ${item.type}? This action cannot be undone.`,
        buttons: [
          {
            text: 'Cancel',
            onPress: null,
            style: 'cancel',
          },
          {
            text: 'Delete',
            onPress: () => deleteItem(item),
            style: 'destructive',
          }
        ]
      });
    }else{
      props.deleteLocalItem(item);
    }
  }
  const deleteItem = async (item) => {
    setLoading(true);
    if (typeof props.setDisabled === 'function') { props.setDisabled(false); }
    let deleteResult = await props.deleteItem(item);
    if(deleteResult){
      console.log('after delete: ', deleteResult);
      setLoading(false);
      if (typeof props.setDisabled === 'function') { props.setDisabled(false); }
    }
  }

  return (
    <>
      <Alert options={alertOptions} setOptions={setAlertOptions} />
      {/* <TouchableOpacity style={[styles.container, containerDimensions(rowItems, props.which, (props.photo.existing ? Images.project.width : props.photo.width), (props.photo.existing ? Images.project.height : props.photo.height), props.isScrollable)]} onPress={() => {props.showItem(props.which)}}> */}
      <TouchableOpacity style={[styles.container, containerStyle]} onPress={() => {props.showItem(props.which)}}>
        {!props.photo.existing &&
          <Image source={{ uri: props.photo.uri }} style={styles.img} />
        }
        {(props.photo && props.photo.path && props.photo.existing) &&
          <CachedImage source={{ uri: props.photo.path }} style={styles.img} onLoadStart={(e) => loadStart(e)} onLoad={(e) => loadEnd(e)} />
        }
        {(props.photo.existing && loading || (props.photo.uploading)) &&
          <ActivityIndicator size="small" color={Colors.yellow} style={[styles.img, styles.loader]} />
        }
        
        {(props.showDelete && !loading && !props.photo.uploading) && 
          <TouchableOpacity style={styles.removeContainer} onPress={() => promptDeleteItem(props.photo)} activeOpacity={0.6} >
            <AntDesign name="closecircleo" size={30} color='white' style={styles.removeIcon2} />
            <AntDesign name="closecircle" size={30} color={Colors.red} style={styles.removeIcon2} />
          </TouchableOpacity>
        }
        {(props.requiresApproval && (!props.photo.accepted || !props.photo.caption_accepted)) &&
          <TouchableOpacity activeOpacity={0.6} onPress={() => props.pendingApprovalAlert('image')} style={styles.notAccepted}>
            <AntDesign name="exclamationcircleo" size={30} color={Colors.blue} style={styles.notAcceptedIcon} />
            <AntDesign name="exclamationcircle" size={30} color={Colors.yellow} style={styles.notAcceptedIcon} />
          </TouchableOpacity>
        }
        {/* {props.photo.caption.length >= 1 &&  */}
        {props.captions &&
          // <TouchableOpacity style={styles.captionOverlay} onPress={() => props.editCaption(props.which)} activeOpacity={0.6}>
          <ScrollView style={styles.captionOverlay}>
            <Text style={[CS.miniText, CS.lightText]}>{props.photo.caption}</Text>
          </ScrollView>
        }
        {/* } */}
      </TouchableOpacity>
    </>
  );
}



